// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__W3sTU"};